(function () {
  'use strict';

  function initPartners() {
    document.querySelectorAll('[data-exode-partners]').forEach((container) => {
      container.addEventListener('mouseenter', () => {
        container.querySelectorAll('.exode-home-partners__track').forEach((track) => {
          track.style.animationPlayState = 'paused';
        });
      });
      container.addEventListener('mouseleave', () => {
        container.querySelectorAll('.exode-home-partners__track').forEach((track) => {
          track.style.animationPlayState = '';
        });
      });
    });
  }

  function initTestimonials() {
    document.querySelectorAll('[data-exode-testimonials-slider]').forEach((slider) => {
      const track = slider.querySelector('[data-exode-testimonials-track]');
      if (!track) return;

      const getSlideWidth = () => {
        const slide = track.querySelector('.exode-home-testimonials__slide');
        if (!slide) return track.clientWidth;
        const gap = parseFloat(getComputedStyle(track).gap) || 0;
        return slide.offsetWidth + gap;
      };

      slider.querySelector('[data-exode-testimonials-prev]')?.addEventListener('click', () => {
        track.scrollBy({ left: -getSlideWidth(), behavior: 'smooth' });
      });

      slider.querySelector('[data-exode-testimonials-next]')?.addEventListener('click', () => {
        track.scrollBy({ left: getSlideWidth(), behavior: 'smooth' });
      });
    });
  }

  function initReviewToggle() {
    document.querySelectorAll('[data-exode-review-toggle]').forEach((btn) => {
      const form = btn.closest('.exode-home-testimonials__header')?.querySelector('[data-exode-review-form]');
      if (!form) return;

      btn.addEventListener('click', () => {
        const open = form.hidden;
        form.hidden = !open;
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  function initFeaturedSlider() {
    document.querySelectorAll('[data-exode-featured-slider]').forEach((slider) => {
      const track = slider.querySelector('[data-exode-featured-track]');
      if (!track) return;

      const getSlideWidth = () => {
        const slide = track.querySelector('.exode-home-featured__item');
        if (!slide) return track.clientWidth;
        const gap = parseFloat(getComputedStyle(track).gap) || 0;
        return slide.offsetWidth + gap;
      };

      slider.querySelector('[data-exode-featured-prev]')?.addEventListener('click', () => {
        track.scrollBy({ left: -getSlideWidth(), behavior: 'smooth' });
      });

      slider.querySelector('[data-exode-featured-next]')?.addEventListener('click', () => {
        track.scrollBy({ left: getSlideWidth(), behavior: 'smooth' });
      });
    });
  }

  function init() {
    initPartners();
    initTestimonials();
    initReviewToggle();
    initFeaturedSlider();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
